import { useOutletContext } from 'react-router-dom';
import Hero from '../components/sections/Hero';
import ProblemAgitation from '../components/sections/ProblemAgitation';
import Methodology from '../components/sections/Methodology';
import FeaturedCaseStudies from '../components/sections/FeaturedCaseStudies';
import StatsBar from '../components/sections/StatsBar';
import Testimonials from '../components/sections/Testimonials';
import BlogPreview from '../components/sections/BlogPreview';
import CTASection from '../components/sections/CTASection';

export default function HomePage() {
  const { settings } = useOutletContext();

  return (
    <>
      <Hero settings={settings} />
      <ProblemAgitation />
      <Methodology settings={settings} />
      <FeaturedCaseStudies />
      <StatsBar />
      <Testimonials />
      <BlogPreview />
      <CTASection settings={settings} />
    </>
  );
}
